/**
 * Woo Cart Ajax
 * ======================================
 * - add cart counter after page load
 * - you can use cache plugins now
 */

const ELEMENTS = '.js-woo-cart_count'
const LOADING_CLASS = 'is-loading'

class WooCart {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS)
    this.localStorage_count = localStorage.getItem("woo-cart_count")
    this.ajaxUrl = '/app/themes/ipress/ajax/index.php'

    if(this.localStorage_count){
      this.set(this.localStorage_count)
    }

    window.addEventListener('load', this.loadHandler)
  }

  loadHandler = () => {
    const xhr = new XMLHttpRequest()
    xhr.open('POST', this.ajaxUrl, true)
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send("action=WooCart");

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText)

          this.set(response.count)

          localStorage.setItem("woo-cart_count", response.count);
        }
        // error
        else {
          console.log('ajaxForm error!', xhr)
        }
      }
    }
  }

  set = (value) => {
    this.elements.forEach(el => {
      el.innerHTML = value
      el.classList.remove(LOADING_CLASS)
    })
  }
}

new WooCart()
